import { RefinePanel } from './RefinePanel';
import { Drawer } from '../ui/Drawer';

interface RefineTurn {
  role: 'user' | 'assistant';
  text: string;
}

interface RefineDrawerProps {
  sectionId: string;
  sectionTitle: string;
  onSend: (message: string) => void;
  onClose: () => void;
  turns: RefineTurn[];
  streaming: boolean;
  streamingText: string;
  turnsUsed?: number;
  turnsMax?: number;
}

export function RefineDrawer(props: RefineDrawerProps) {
  return (
    <>
      {/* Desktop: inline below card */}
      <div className="hidden sm:block">
        <RefinePanel {...props} />
      </div>

      {/* Mobile: bottom sheet */}
      <div className="sm:hidden">
        <Drawer open={true} onClose={props.onClose} position="bottom">
          <div className="flex justify-center mb-3">
            <div className="w-10 h-1 bg-border rounded-full" />
          </div>
          <RefinePanel {...props} />
        </Drawer>
      </div>
    </>
  );
}
